var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showAvmDetail()
    ? _c(
        "el-card",
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c(
              "div",
              { staticClass: "title header-section" },
              [
                _c("span", [_vm._v("AVM Information")]),
                _c(
                  "el-button",
                  {
                    staticClass: "edit-button",
                    attrs: { type: "success" },
                    on: { click: _vm.toggleEditMode },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.isEditMode ? "Submit" : "Edit AVM Summary") +
                        " "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm.showAvmUpload()
            ? _c("avm-upload", {
                staticClass: "ca-card",
                attrs: { isEdit: _vm.isEdit, "v-model": _vm.modelValue },
              })
            : _vm._e(),
          _vm.showAvmSummary()
            ? _c("div", { staticClass: "ca-form" }, [
                _c("div", { staticClass: "ca-section" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("Subject Property Summary"),
                  ]),
                  !_vm.isEditMode
                    ? _c(
                        "div",
                        { staticClass: "ca-single-line" },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "w100",
                              attrs: { label: "Address" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("uppercase")(
                                      _vm.modelValue.avmData.subjectStreet
                                    )
                                  ) +
                                  ", " +
                                  _vm._s(
                                    _vm._f("uppercase")(
                                      _vm.modelValue.avmData.subjectCity
                                    )
                                  ) +
                                  ", " +
                                  _vm._s(
                                    _vm._f("uppercase")(
                                      _vm.modelValue.avmData.subjectState
                                    )
                                  ) +
                                  " " +
                                  _vm._s(_vm.modelValue.avmData.subjectZip) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "w50", attrs: { label: "County" } },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.modelValue.subjectCounty) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isEditMode
                    ? _c(
                        "div",
                        { staticClass: "ca-single-line" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Street" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.modelValue.avmData.subjectStreet,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.modelValue.avmData,
                                      "subjectStreet",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "modelValue.avmData.subjectStreet",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "City" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.modelValue.avmData.subjectCity,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.modelValue.avmData,
                                      "subjectCity",
                                      $$v
                                    )
                                  },
                                  expression: "modelValue.avmData.subjectCity",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "State" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.modelValue.avmData.subjectState,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.modelValue.avmData,
                                      "subjectState",
                                      $$v
                                    )
                                  },
                                  expression: "modelValue.avmData.subjectState",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Zip Code" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.modelValue.avmData.subjectZip,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.modelValue.avmData,
                                      "subjectZip",
                                      $$v
                                    )
                                  },
                                  expression: "modelValue.avmData.subjectZip",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "County" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.modelValue.subjectCounty,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.modelValue,
                                      "subjectCounty",
                                      $$v
                                    )
                                  },
                                  expression: "modelValue.subjectCounty",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isEditMode
                    ? _c(
                        "div",
                        { staticClass: "ca-single-line" },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "w50",
                              attrs: { label: "Borrower(s)" },
                            },
                            [_vm._v(" " + _vm._s(_vm.getBorrowerNames()) + " ")]
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "w50",
                              attrs: { label: "Lender Name" },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.modelValue.lenderName) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isEditMode
                    ? _c(
                        "div",
                        { staticClass: "ca-single-line" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Borrower(s)" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.modelValue.borrowerName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.modelValue,
                                      "borrowerName",
                                      $$v
                                    )
                                  },
                                  expression: "modelValue.borrowerName",
                                },
                              }),
                              _c("el-input", {
                                model: {
                                  value: _vm.modelValue.borrowerName2,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.modelValue,
                                      "borrowerName2",
                                      $$v
                                    )
                                  },
                                  expression: "modelValue.borrowerName2",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Lender Name" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.modelValue.lenderName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.modelValue, "lenderName", $$v)
                                  },
                                  expression: "modelValue.lenderName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm.modelValue.avmData
                  ? _c("div", { staticClass: "ca-section" }, [
                      _c("div", { staticClass: "title header-section" }, [
                        _c("span", [_vm._v("AVM Summary")]),
                      ]),
                      !_vm.isEditMode
                        ? _c(
                            "div",
                            { staticClass: "ca-single-line" },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "Model Name" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.modelValue.avmData.product) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "AVM Value" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("currency0")(
                                          _vm.modelValue.avmData.value
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("el-form-item", { attrs: { label: "FSD" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("fixed3")(
                                        _vm.modelValue.avmData.fsd
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _c(
                                "el-form-item",
                                { attrs: { label: "Confidence Score" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("fixed2")(
                                          _vm.modelValue.avmData.confidence
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isEditMode
                        ? _c(
                            "div",
                            { staticClass: "ca-single-line" },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "Model Name" } },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.modelValue.avmData.product,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.modelValue.avmData,
                                          "product",
                                          $$v
                                        )
                                      },
                                      expression: "modelValue.avmData.product",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "AVM Value" } },
                                [
                                  _c("el-input", {
                                    attrs: { type: "number" },
                                    model: {
                                      value: _vm.modelValue.avmData.value,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.modelValue.avmData,
                                          "value",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "modelValue.avmData.value",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "FSD" } },
                                [
                                  _c("el-input-number", {
                                    attrs: {
                                      step: 0.01,
                                      min: 0,
                                      max: 100.0,
                                      precision: 2,
                                    },
                                    model: {
                                      value: _vm.modelValue.avmData.fsd,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.modelValue.avmData,
                                          "fsd",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "modelValue.avmData.fsd",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "Confidence Score" } },
                                [
                                  _c("el-input-number", {
                                    attrs: {
                                      step: 1,
                                      min: 0,
                                      max: 100.0,
                                      precision: 0,
                                    },
                                    model: {
                                      value: _vm.modelValue.avmData.confidence,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.modelValue.avmData,
                                          "confidence",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "modelValue.avmData.confidence",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "ca-section" }, [
                  _c("div", { staticClass: "title" }, [
                    _c("span", [_vm._v("Reviewer Summary")]),
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit",
                        },
                      ],
                      staticClass: "instructions",
                    },
                    [
                      _c("ol", [
                        _c(
                          "li",
                          [
                            _vm._v(" Click "),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: { click: _vm.triggerViewReport },
                              },
                              [_vm._v(" View Report ")]
                            ),
                            _vm._v(
                              " to open the pdf in a new browser window. "
                            ),
                          ],
                          1
                        ),
                        _c("li", [
                          _vm._v(
                            "Carefully answer each question while reviewing the report."
                          ),
                        ]),
                        _c("li", [
                          _vm._v(
                            "Provide your name and add Comments if necessary."
                          ),
                        ]),
                        _c("li", [
                          _vm._v("Click Submit to complete the process."),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "ca-avm-questions" },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            id: "avm-questions-table",
                            data: _vm.list,
                            border: "",
                            fit: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { width: "50", label: "#", align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.getNumber(row))),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4185300926
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Question" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c("div", { staticClass: "wrap-text" }, [
                                        _vm._v(
                                          " " + _vm._s(row.question) + " "
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2709134175
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { width: "200px", label: "Answer" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        staticStyle: { "text-align": "center" },
                                        attrs: {
                                          readonly: !_vm.isEdit,
                                          size: "small",
                                        },
                                        nativeOn: {
                                          keyup: function ($event) {
                                            return _vm.handleChange.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                        model: {
                                          value: scope.row.answer,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "answer", $$v)
                                          },
                                          expression: "scope.row.answer",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1748537502
                            ),
                          }),
                        ],
                        1
                      ),
                      _vm.modelValue.avmData
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "ca-bordered",
                              attrs: { label: "Comments" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  readonly: !_vm.isEdit,
                                  type: "textarea",
                                  rows: "3",
                                },
                                nativeOn: {
                                  keyup: function ($event) {
                                    return _vm.handleChange.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.modelValue.avmData.comments,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.modelValue.avmData,
                                      "comments",
                                      $$v
                                    )
                                  },
                                  expression: "modelValue.avmData.comments",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.modelValue.avmData
                    ? _c(
                        "div",
                        { staticClass: "ca-single-line" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Summary Provided By" } },
                            [
                              _c("el-input", {
                                attrs: { readonly: !_vm.isEdit },
                                nativeOn: {
                                  keyup: function ($event) {
                                    return _vm.handleChange.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.modelValue.avmData.summaryProvidedBy,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.modelValue.avmData,
                                      "summaryProvidedBy",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "modelValue.avmData.summaryProvidedBy",
                                },
                              }),
                              _vm.modelValue.avmData.lastModifiedDate
                                ? _c("span", { staticClass: "instructions" }, [
                                    _vm._v(
                                      " Last Updated: " +
                                        _vm._s(
                                          _vm._f("parseDateTime")(
                                            _vm.modelValue.avmData
                                              .lastModifiedDate
                                          )
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            [
                              _vm.isEdit
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        disabled: !(
                                          _vm.submitting || _vm.hasChanges
                                        ),
                                      },
                                      on: { click: _vm.saveChanges },
                                    },
                                    [
                                      _vm.submitting
                                        ? _c("span", [
                                            _vm._v("Submitting changes..."),
                                          ])
                                        : _c("span", [
                                            _vm._v("Submit AVM Review"),
                                          ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }